import { createStripeWalletPaymentAttempt } from './stripeWallet';
import applePayFactory from '../../payments/core/factories/applepay';

/**
 * Initiates a Stripe Apple Pay payment attempt using a ConfirmationToken created on the client
 * from the Express Checkout Element.
 *
 * Thin wrapper over the shared `createStripeWalletPaymentAttempt` factory bound to Apple Pay:
 * `payment_type: apple_pay`, the Apple Pay core payments factory, and the `stripe` / `apple_pay`
 * engine/provider defaults. paymentPollingHandler owns terminal outcomes; only
 * `requires_client_action` (3DS over FPAN) is intercepted and returned.
 *
 * @param {string} purchaseToken - The token associated with the purchase.
 * @param {Object} paymentData - The Stripe Apple Pay payment data.
 * @param {string} paymentData.confirmationTokenId - Stripe ConfirmationToken ID from the ECE.
 * @param {Object} [paymentData.walletInfo] - Wallet info from the ECE confirm event (e.g.
 *   payment_method_preview data such as brand/funding).
 * @returns {Function} A thunk action that dispatches actions based on the payment flow.
 */
export const stripeApplePayPaymentAttempt = createStripeWalletPaymentAttempt({
  paymentType: 'apple_pay',
  factory: applePayFactory,
  defaultProvider: 'apple_pay',
});

export default stripeApplePayPaymentAttempt;
